
import React from 'react';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { FormattedInstagramPost, uploadedExampleImage } from '@/utils/instagram';
import { useIsMobile } from '@/hooks/use-mobile';

interface InstagramPostCardProps {
  post: FormattedInstagramPost;
  index: number;
}

const InstagramPostCard: React.FC<InstagramPostCardProps> = ({ post, index }) => {
  const isMobile = useIsMobile();

  return (
    <a 
      href={post.link}
      target="_blank"
      rel="noopener noreferrer"
      className="instagram-post overflow-hidden relative"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <AspectRatio ratio={4 / 5} className="w-full h-full">
        <img
          src={post.imageUrl}
          alt={`Instagram post ${index + 1}`}
          className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
          onError={(e) => {
            // Fallback for image loading errors
            const target = e.target as HTMLImageElement;
            target.onerror = null;
            target.src = uploadedExampleImage;
          }}
        />
      </AspectRatio>
      
      {/* Show Reel indicator if it's a reel */}
      {post.isReel && (
        <div className="absolute top-2 right-2">
          <div className="bg-black/70 text-white text-xs px-2 py-1 rounded-full flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 mr-1">
              <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
            </svg>
            Reel
          </div>
        </div>
      )}
      
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-2">
        {!isMobile && (
          <p className="text-white text-xs line-clamp-2 mb-1">{post.caption}</p>
        )}
        <div className="flex items-center text-white text-xs">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-3 h-3 mr-1">
            <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
          </svg>
          {post.likes}
        </div>
      </div>
    </a>
  );
};

export default InstagramPostCard;
